<template>
  <div>
    <!-- Header Filter & Suchen -->
    <div class="bg-custom-blue">
      <div class="container">
        <div class="row py-2">
          <div class="form-check form-switch mx-4 py-2 col-3">
            <input v-model="switchValid" type="checkbox" role="switch" id="switchValid" class="form-check-input">
            <label class="switchValid" for="switchValid">{{ $t("views.my.responsibilities.switchValid") }}</label>
          </div>
          <div class="col-3 ms-auto">
            <input v-model="filterName" type="text" class="form-control form-control-sm" :placeholder='$t("general.placeholderSearch")'>
          </div>
        </div>
      </div>
    </div>

    <!-- Datensätze verfügbar-->
    <div v-if="filteredResponsibilities.length" class="container my-3">
      <!-- Title & Infobutton-->
      <div class="row">
        <div class="col-12">
          <div class="h4">
            {{ $t("views.my.responsibilities.headingTitle") }}
            ({{this.$store.state.user.lastName}}, {{this.$store.state.user.firstName}})
          </div>
        </div>
      </div>

      <div class="bg-white rounded-2 p-2 mt-4">
      <div class="row">
        <div class="col-12">
          <div class="">
            <!-- Spaltenüberschriften -->
            <div class="row fw-bold px-3 border-bottom py-2">
              <div class="col-4 text-start px-1">
                {{ $t("views.my.responsibilities.RelatedObject") }}
              </div>
              <div class="col-1 text-start px-1">
                {{ $t("views.my.responsibilities.ValidFrom") }}
              </div>
              <div class="col-1 text-start px-1">
                {{ $t("views.my.responsibilities.ValidTo") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <!-- Spalteninhalte-->
           <div v-for="responsibility in filteredResponsibilities" :key="responsibility.id" class="row px-3 border-bottom">
              <!-- verbundene Objekte -->
              <div class="col-4 text-start px-1 py-2">
                <div v-if="responsibility.type === 'orgunit'" >
                  <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconOrgUnit'"> <use xlink:href="@/assets/icons/icons.svg#orgunit" /> </svg> &nbsp;
                  <a :href="createLink('orgunit', responsibility.parentObjectUuid)" target="_blank"> {{ responsibility.name }} </a>
                </div>
                <div v-if="responsibility.type === 'strategy'" >
                  <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconStrategy'"> <use xlink:href="@/assets/icons/icons.svg#strategy" /> </svg> &nbsp;
                  <a :href="createLink('strategy', responsibility.parentObjectUuid)" target="_blank"> {{ responsibility.name }} </a>
                </div>
                <div v-if="responsibility.type === 'objective'" >
                  <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconObjective'"> <use xlink:href="@/assets/icons/icons.svg#objective" /> </svg> &nbsp;
                  <a :href="createLink('objective', responsibility.parentObjectUuid)" target="_blank"> {{ responsibility.name }} </a>
                </div>
                <div v-if="responsibility.type === 'project'" >
                  <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconProject'"> <use xlink:href="@/assets/icons/icons.svg#project" /> </svg> &nbsp;
                  <a :href="createLink('project', responsibility.parentObjectUuid)" target="_blank"> {{ responsibility.name }} </a>
                </div>
                <div v-if="responsibility.type === 'kpi'" >
                  <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconKpi'"> <use xlink:href="@/assets/icons/icons.svg#kpi" /> </svg> &nbsp;
                  <a :href="createLink('kpi', responsibility.parentObjectUuid)" target="_blank"> {{ responsibility.name }} </a>
                </div>
              </div>
              <div class="col-1 text-start px-1 py-2">
                {{ formatDate(new Date(responsibility.validFrom)) }}
              </div>
              <div class="col-1 text-start px-1 py-2">
                {{ formatDate(new Date(responsibility.validTo)) }}
              </div>
          </div>
        </div>
      </div>

      </div>
    </div>
    <!-- Fehlermeldung "No Data"          -->
    <div v-else-if="!loadingStatus" class="text-center mt-5">
      <img src="@/assets/img/no_data.svg" class="img-fluid" width="250">
      <p class="h5 mt-3">{{ $t("views.my.responsibilities.noResponsibilities") }}.</p>
    </div>
  </div>
</template>

<script>
import * as formatUtils from '../../composables/formatUtils'

export default {
  name: 'MyResponsibilities',
  data () {
    return {
      filterName: '',
      switchValid: true
    }
  },
  computed: {
    myResponsibilitiesArray () {
      return this.$store.state.myResponsibilities.responsibilities
    },
    filteredResponsibilities () {
      if (this.myResponsibilitiesArray) {
        return this.myResponsibilitiesArray.filter(responsibility => {
          if (this.switchValid) {
            return responsibility.name.toLowerCase().includes(this.filterName.toLowerCase()) && new Date(responsibility.validTo) >= new Date()
          } else {
            return responsibility.name.toLowerCase().includes(this.filterName.toLowerCase())
          }
        })
      } else {
        return []
      }
    },
    loadingStatus () {
      return this.$store.state.loadingStatus
    },
    actualYear () {
      const actualYear = new Date().getFullYear()
      return actualYear
    }
  },
  methods: {
    async getMyResponsibilities () {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('getMyResponsibilities', this.selectedEmployee)
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    createLink (type, uuid) {
      let url = ''
      if (type === 'orgunit') url = '/organization/manage/org-units?id=' + uuid
      if (type === 'strategy') url = '/strategies/manage/strategies?id=' + uuid
      if (type === 'objective') url = '/objectives/manage/objectives?id=' + uuid
      if (type === 'project') url = '/projects/manage/projects?id=' + uuid
      if (type === 'kpi') url = '/monitoring/manage/kpis?id=' + uuid
      return url
    },
    formatPeriod (period) {
      return formatUtils.formatPeriod(period)
    },
    formatDate (date) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.formatDate(userLocale, date)
    }
  },
  async created () {
    this.$store.commit('SET_LOADING_STATUS', true)
    await this.$store.dispatch('getMyResponsibilities', this.$store.state.user)
    this.$store.commit('SET_LOADING_STATUS', false)
  }
}
</script>

<style scoped>
.container {
  max-width: 1600px;
}
.col-Measure-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-th {
  background-color: transparent;
  border: 0;
  font-weight: bold;
}
</style>
<style lang="scss" scoped>
.progress-label {
  transform: translate(-50%, -50%);
}
.tab-content .progress {
  margin-top: 6px;
}
</style>
